import { useEffect, useState, useMemo, useContext } from "react";
import { Card, CardContent, Typography, Box, Drawer, TextField } from "@mui/material";
import { getNoRecentVisitMap } from "../../../../utils/services/APP/NoRecentVisit/getNoRecentVisitMap";
import NoRecentVisitTable from "./NoRecentVisitComp/NoRecentVisitTable";
import { NoRecentVisitContext } from '../../../../context/PatientContext/NoRecentVisitContext/NoRecentVisitContext';
import NoRecentVisitDetail from "./NoRecentVisitComp/NoRecentVisitDetail";
import { columnsNoRecentVisit } from "../../../../themes/ColumsTools";
import TableTools from "../Complements/TableTools";
import ColumnSelector from "../Complements/ColumnSelector";


    
const NoRecentVisit = () => {
    const {
        NoRecentVisitPatients: rows,
        loading,
        page,
        pageSize,
        setPage,
        setPageSize,
        total,
        fetchNoRecentVisitDetails
    } = useContext(NoRecentVisitContext);
    const [selectedCenter, setSelectedCenter] = useState('All');
    const [detailOpen, setDetailOpen] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [NoRecentVisit, setNoRecentVisit] = useState({});
    const [selectedRow, setSelectedRow] = useState(null);
    const [columnVisibilityModel, setColumnVisibilityModel] = useState({});

    const handleAddPatient = (newPatient) => {
        setData(prev => {
            const exists = prev.some(patient => patient.MemberID === newPatient.MemberID);
            if (exists) {
            // Reemplazar el paciente existente por el nuevo
            return prev.map(patient =>
                patient.MemberID === newPatient.MemberID ? newPatient : patient
            );
            } else {
            // Agregar el nuevo paciente al final
            return [...prev, newPatient];
            }
        });
    };

    const[data,setData]=useState([])
    useEffect(() => {
        const Information = getNoRecentVisitMap();
        setData(Information.data);
        //setAlldata(Information)
        setNoRecentVisit(Information.medicalCenters);
    }, []);
    
    // useEffect(() => {
    //     console.log(rows)
    //   }, [rows]);

    const handleRowClick = (row) => {
        setSelectedRow(row);
        fetchNoRecentVisitDetails(row.cipId);
        setDetailOpen(true);
    };
    // const counts = useMemo(() => {
    //     const grouped = {};
    //     data.forEach(item => {
    //     grouped[item.medicalCenter] = (grouped[item.medicalCenter] || 0) + 1;
    //     });
    //     return grouped;
    // }, [data]);

    const filteredData = useMemo(() => {
        let filtered = selectedCenter === 'All'
            ? data
            : data.filter(item => item.MedicalCenters === selectedCenter);

        if (searchText.trim()) {
            filtered = filtered.filter(item =>
            item.MemberFullName.toLowerCase().includes(searchText.toLowerCase())
            );
        }
        return filtered;
    }, [selectedCenter, data, searchText]);
    
  return (
    <Box sx={{ p: 3 }}>
        <Typography variant="h4" gutterBottom>
            No Recent Visit
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 1 }}>
            <TextField
                placeholder="Member Name"
                size="small"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                sx={{ width: '60%' }}
            />
            <ColumnSelector
                columns={columnsNoRecentVisit}
                columnVisibilityModel={columnVisibilityModel}
                setColumnVisibilityModel={setColumnVisibilityModel}
            />
        </Box>
        <Box sx={{ borderBottom: '1px solid #ddd', mb: 2 }} />
        {/* Contenedor principal en fila */}
        <Box sx={{ display: 'flex', gap: 2 }}>
            
            {/* Sidebar */}
            <Box
                sx={{
                    width: 200,
                    pr: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1,
                }}
                >
                {Object.entries(NoRecentVisit).map(([key, value]) => (
                <Box
                    key={key}
                    onClick={() => setSelectedCenter(key)}
                    sx={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    backgroundColor: selectedCenter === key ? '#d1f2eb' : 'transparent',
                    borderRadius: '999px',
                    px: 2,
                    py: 0.5,
                    fontWeight: selectedCenter === key ? 'bold' : 'normal',
                    border: selectedCenter === key ? '1px solid #117a65' : 'none',
                    color: selectedCenter === key ? '#117a65' : 'inherit',
                    cursor: 'pointer',
                    '&:hover': {
                        backgroundColor: '#d1f2eb',
                    },
                    }}
                >
                    {key}{' '}
                    <span style={{ color: '#aaa', marginLeft: 4 }}>
                    ({value || 0})
                    </span>
                </Box>
                ))}

            </Box>


            {/* Contenido principal con la tabla */}
            <Box sx={{ flex: 1, minWidth: 0 }}>
                <Card>
                    <CardContent sx={{ p: 0 }}>
                        <Box sx={{ 
                            height: 700, 
                            overflowY: "auto"
                            }}>
                        <TableTools
                            rows={rows}
                            loading={loading}
                            page={page}
                            pageSize={pageSize}
                            rowCount={total}
                            setPage={setPage}
                            setPageSize={setPageSize}
                            columns={columnsNoRecentVisit}
                            onRowClick={handleRowClick}
                            columnVisibilityModel={columnVisibilityModel}
                            setColumnVisibilityModel={setColumnVisibilityModel}
                        />
                        </Box>
                    </CardContent>
                </Card>
            </Box>
        </Box>
        <Drawer anchor="right" open={detailOpen} onClose={() => setDetailOpen(false)}>
            <Box width={650} p={3}>
                <NoRecentVisitDetail
                    modificar={ selectedRow?? [] }
                    open={detailOpen}
                    onClose={() => setDetailOpen(false)}
                    onSave={(newReferral) => {
                        handleAddPatient(newReferral);
                        setDetailOpen(false);
                    }}
                />
            </Box>
        </Drawer>
    </Box>
    
  );
};


export default NoRecentVisit;

